/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createComplexClass } from '../../factoriesAny.js';
export var ComplexDependencies = {
  createComplexClass: createComplexClass
};